module.exports = __webpack_public_path__ + "img/126.9bcf859c.jpg";